import React from "react";

interface Props {
  amount: string;
}

const LifetimeTermsNote: React.FC<Props> = ({ amount }) => {
  return (
    <p className="terms-note" id="termsNote">
      One-off payment of {amount}. Lifetime access to every current and future
      42courses course. By continuing you agree to our{" "}
      <a href="/terms">Terms and Conditions</a>.
    </p>
  );
};

export default LifetimeTermsNote;
